export default {
    label: 'Timezone',
    placeholder: 'Αναζήτηση timezone...',
    noOptions: 'Δεν βρέθηκαν timezones',
    mismatchWarning: {
        title: 'Το timezone του browser σας δεν ταιριάζει με το επιλεγμένο',
        detected: 'Timezone του browser',
        useDetected: 'Χρήση του προτεινόμενου'
    }
}

